(() => {
  'use strict';
  function init(gallery) {
    if (gallery.dataset.galleryReady) return;
    gallery.dataset.galleryReady = 'true';
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const image = gallery.querySelector('[data-gallery-image]');
    const caption = gallery.querySelector('[data-gallery-caption]:not([data-gallery-thumb])');
    const count = gallery.querySelector('[data-gallery-count]');
    const strip = gallery.querySelector('.vdr-gallery-thumbs');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const zoom = gallery.querySelector('[data-gallery-zoom]');
    const large = gallery.querySelector('[data-gallery-large]');
    let current = 0;
    function syncDialog() {
      const item = thumbs[current];
      large.src = item.href;
      large.alt = item.dataset.galleryCaption;
      gallery.querySelector('[data-gallery-dialog-caption]').textContent = item.dataset.galleryCaption;
      gallery.querySelector('[data-gallery-dialog-count]').textContent = `${current + 1} / ${thumbs.length}`;
    }
    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      const item = thumbs[current];
      image.srcset = item.dataset.gallerySrcset;
      image.src = item.href;
      image.alt = item.dataset.galleryCaption;
      caption.textContent = item.dataset.galleryCaption;
      count.textContent = `${current + 1} / ${thumbs.length}`;
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
        if (i === current) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const thumbRect = item.getBoundingClientRect(), stripRect = strip.getBoundingClientRect();
      if (thumbRect.left < stripRect.left || thumbRect.right > stripRect.right) {
        strip.scrollLeft += thumbRect.left - stripRect.left - (strip.clientWidth - item.clientWidth) / 2;
      }
      if (dialog.open) syncDialog();
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', event => {
      event.preventDefault();
      show(i);
    }));
    gallery.querySelectorAll('[data-gallery-prev]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => show(current - 1));
    });
    gallery.querySelectorAll('[data-gallery-next]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => show(current + 1));
    });
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
      if (!dialog.open && event.target.matches('[data-gallery-thumb]')) thumbs[current].focus({preventScroll:true});
    });
    if (typeof dialog.showModal === 'function') {
      zoom.hidden = false;
      zoom.addEventListener('click', () => { syncDialog(); dialog.showModal(); });
      gallery.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => zoom.focus({preventScroll:true}));
    }
  }
  document.querySelectorAll('[data-drawer-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-drawer-gallery]').forEach(init));
})();
